import React from 'react'
import {
  Autocomplete,
  CircularProgress,
  InputAdornment,
  TextField
} from '@mui/material'
import {Controller, useFormContext} from 'react-hook-form'
import {resolve} from 'src/utils/utils'

export interface AutocompleteOption {
  id: string
  label: string
}

export interface SearchProps {
  options: any[]
  name: string
  label: string
  getValue: (o: any) => any
  loading?: boolean
  onChange?: (value: any | null) => void
  selectedValue?: any | null
}

const AutoComplete = (props: SearchProps) => {
  const {
    control,
    formState: {errors}
  } = useFormContext()
  const error = resolve(props.name, errors)

  return (
    <Controller
      control={control}
      name={props.name}
      render={({field: {onChange, ...field}}) => {
        return (
          <Autocomplete
            {...field}
            sx={{width: '100%'}}
            disablePortal
            fullWidth
            clearOnBlur={false}
            openOnFocus
            noOptionsText={'אין תוצאות'}
            options={props.options}
            value={
              props.selectedValue !== undefined
                ? props.selectedValue
                : props.options.find(o => props.getValue(o) === field.value) ||
                  null
            }
            getOptionLabel={option => option.label || option}
            onChange={(event: any, newValue: any | null) => {
              onChange(props.getValue(newValue))
              props.onChange?.(newValue)
            }}
            renderInput={params => (
              <TextField
                {...params}
                label={props.label}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: props.loading ? (
                    <InputAdornment position="end">
                      <CircularProgress size={24} />
                    </InputAdornment>
                  ) : (
                    params.InputProps.startAdornment
                  ),
                  endAdornment: (
                    <InputAdornment position="start">
                      {params.InputProps.endAdornment}
                    </InputAdornment>
                  )
                }}
                helperText={error?.message}
                error={!!error}
              />
            )}
          />
        )
      }}
    />
  )
}

export default AutoComplete
